import {
  FETCH_PROJECTS_REQUEST,
  FETCH_PROJECTS_SUCCESS,
  FETCH_PROJECTS_FAILURE,
  DELETE_PROJECT_SUCCESS,
  CLEAR_PROJECT_ERROR
} from '../../actions/projectsActions';

const initialState = {
  projects: [],
  loading: false,
  error: null
};

const projectsList = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROJECTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_PROJECTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        projects: action.payload.items
      };

    case FETCH_PROJECTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        projects: []
      };

    case DELETE_PROJECT_SUCCESS:
      return {
        ...state,
        projects: state.projects.filter(project => project.id !== action.payload),
        totalCount: Math.max(0, state.totalCount - 1)
      };

    case CLEAR_PROJECT_ERROR:
      return {
        ...state,
        error: null
      };

    default:
      return state;
  }
};

export default projectsList;